export default __webpack_public_path__ + "static/media/giveaways-loop.62a419b6.gif";